var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 1.333c.77 0 1.422.51 1.671 1.212h2.477c.652 0 1.185.546 1.185 1.213v9.697c0 .666-.533 1.212-1.185 1.212H3.852c-.652 0-1.185-.546-1.185-1.212V3.758c0-.667.533-1.213 1.185-1.213h2.477c.249-.703.9-1.212 1.671-1.212zM5.037 3.758h-.593a.601.601 0 0 0-.592.606v8.484c0 .334.267.607.592.607h7.112a.601.601 0 0 0 .592-.607V4.364a.601.601 0 0 0-.592-.606h-.593v.606c0 .666-.533 1.212-1.185 1.212H6.222c-.652 0-1.185-.546-1.185-1.212v-.606zm5.037 6.06a.495.495 0 0 1 .062.988l-.062.004h-3.95a.495.495 0 0 1-.062-.988l.061-.004h3.951zm0-1.818a.495.495 0 0 1 .062.988l-.062.004h-3.95a.495.495 0 0 1-.062-.988L6.123 8h3.951zM8 2.545a.601.601 0 0 0-.593.607c0 .333.267.606.593.606a.601.601 0 0 0 .593-.606A.601.601 0 0 0 8 2.545z",
    fill: "#8CAEB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.d4c88335002c5294b4cffc13c6f53bde.svg";
export { ForwardRef as ReactComponent };